import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSitemap, faRibbon, faHandHoldingDollar, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import useFetchTransactions from '../../hooks/fetchTransactions';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import useFetchCauses from '../../hooks/fetchCauses';
import useFetchEvents from '../../hooks/fetchEvents';
import { useNavigate } from 'react-router-dom';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import useFetchTransactionsByOrg from '../../hooks/fetchTransactions By Org';
import moment from 'moment';
import usefetchTransByDateOrg from '../../hooks/fetchTransByDateOrg';
import axios from 'axios';
import { app } from '../../config';
import { data } from 'jquery';
import searchOrganization from '../../hooks/searchOrganization';
import useFetchTransactionsforDashboard from '../../hooks/fetchTransForDashBoard';
import useFetchRecurringPayments from '../../hooks/fetchRecurringPayments';
import usefetchTotalAmountforAdminPanel from '../../hooks/fetchTotalAmountforAdminPanel';

const Dashboard2 = () => {
  const [donationData, setDonationData] = useState([]);
  const token = getTokenfromUserObj();
  const { t } = useTranslation(['common']);
  window.document.title = 'Dashboard';
  let transAmount = 0;
  window.onpopstate = () => {
    console.log('function called on popstate');
    useNavigate(-1);
  };
  const navigate = useNavigate();
  let usersCount, donorCount;
  const user = JSON.parse(localStorage.getItem('user'));
  const totalAmountResp=usefetchTotalAmountforAdminPanel();
  console.log(totalAmountResp);
  transAmount= totalAmountResp?.response?.data?.totalAmount
  console.log(transAmount);
  const transactionRes = useFetchTransactionsforDashboard();
  const transResponse = transactionRes.response ? transactionRes.response.data : [];
  // console.log(transResponse);
  // transResponse.forEach((element) => (transAmount += Number(element.amount)));
  let orgId;
  const recurrPaymentResp= useFetchRecurringPayments(user,orgId)
  console.log("recurrPaymentResp: ")
  let totalRecurring=0;
  totalRecurring=recurrPaymentResp?.response?.data?.totalAmount;
  console.log(totalRecurring);
  const orgRes = useFetchOrganizations();
  const orgs = orgRes.response ? orgRes.response.data : [];
  const orgCount = orgRes.response ? orgRes.response.data.length : [];
  const causeRes = useFetchCauses();
  const causeCount = causeRes.response ? causeRes.response.data.length : [];
  const eventRes = useFetchEvents();
  const eventCount = eventRes.response ? eventRes.response.data.length : [];
  let last24 = {
    startDate: moment().subtract(24, 'hours').format('MM-DD-YYYY 00:00:00'),
    endDate: moment().format('MM-DD-YYYY HH:mm:ss'),
  };
  let lastWeek = {
    startDate: moment().subtract(7, 'd').format('MM-DD-YYYY 00:00:00'),
    endDate: moment().format('MM-DD-YYYY HH:mm:ss'),
  };
  let lastMonth = {
    startDate: moment().subtract(1, 'months').format('MM-DD-YYYY 00:00:00'),
    endDate: moment().format('MM-DD-YYYY HH:mm:ss'),
  };
  let lastYear = {
    startDate: moment().subtract(1, 'year').format('MM-DD-YYYY 00:00:00'),
    endDate: moment().format('MM-DD-YYYY HH:mm:ss'),
  };

  console.log(moment().subtract(24, 'hours').format('MM-DD-YYYY 00:00:00'));
  console.log(moment().format('MM-DD-YYYY HH:mm:ss'));
  const transByDateResp = usefetchTransByDateOrg(last24);
  const transRespforweek = usefetchTransByDateOrg(lastWeek);
  const transRespforMonth = usefetchTransByDateOrg(lastMonth);
  const last24Data = transByDateResp.response ? transByDateResp.response.data : [{ organization: '', last24: '', lastweek: '', lastmonth: '' }];
  const lastWeekResp = transRespforweek.response ? transRespforweek.response.data : [{ organization: '', last24: '', lastweek: '', lastmonth: '' }];
  const lastMonthResp = transRespforMonth.response ? transRespforMonth.response.data : [{ organization: '', last24: '', lastweek: '', lastmonth: '' }];
  const renderData = () => {
    let dataToRender = [{ organization: '', last24: '', lastweek: '', lastmonth: '' }];
    transByDateResp.response
      ? last24Data.forEach((data) => {
          if (Object.keys(data)[0] === Object.keys(dataToRender[0])[0]) {
            dataToRender.push({ organization: data.organization, last24: data.amount, lastweek: '', lastmonth: '' });
          }
        })
      : ' ';

    dataToRender.shift();
    transRespforweek.response
      ? lastWeekResp.forEach((data, index) => {
          if (data.organization == dataToRender[index].organization) {
            dataToRender[index].lastweek = data.amount;
          }
        })
      : ' ';
    console.log(dataToRender);
    transRespforMonth.response
      ? lastMonthResp.forEach((data, index) => {
          if (data.organization == dataToRender[index].organization) {
            dataToRender[index].lastmonth = data.amount;
          }
        })
      : ' ';
    return dataToRender;
  };
  const toDonationReport = async (output) => {
    console.log(output.organization);
    const res = await axios.get(`${app.URL}/org/search/${output.organization}`, { headers: { auth: token } });
    console.log(res);
    const org = res.data ? res.data.data[0] : ' ';
    console.log(org);
    if (org) {
      localStorage.setItem('org', org.organizationId);
      navigate('/reports/donation');
    }
  };

  useEffect(() => {
    let response = [];
    transByDateResp.response ? (response = renderData()) : ' ';
    setDonationData(response);
    console.log(donationData);
  }, [lastMonthResp]);

  console.log(user.userType);

  return (
    <div style={{ maxWidth: '100%', marginLeft: '-20px' }} class='col-lg-12 col-md-12 col-sm-12 main pt-5 mt-3'>
      <div class='row mb-3'>
        <div class='col-xl-3 col-m-4 col-sm-6 py-2'>
          <div class='card text-white gradient1 h-100'>
            <div class='card-body '>
              <div class='rotate'></div>
              <h6 class='text-uppercase text-white fw-bold'>{t('Organizations')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='mr-2 fa-2xl' icon={faSitemap} />
              <h1 class='display-5 text-white '>{orgCount < 10 ? '0' + orgCount : orgCount}</h1>
              {/* <h1 class="display-4 text-white ">{orgsList?orgsList.length:" "}</h1> */}
            </div>
          </div>
        </div>
        <div class='col-xl-3 col-sm-6 py-2'>
          <div class='card text-white gradient2 h-100'>
            <div class='card-body '>
              <div class='rotate'>
                <i class='fa fa-list fa-4x'></i>
              </div>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Users")}</h6> */}
              <h6 class='text-uppercase text-white fw-bold'>{t('Causes')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='mr-2 fa-2xl' icon={faRibbon} />
              <h1 class='display-5 text-white'>{causeCount < 10 ? '0' + causeCount : causeCount}</h1>
              {/* <h1 class="display-4 text-white">{usersCount?usersCount:" "}</h1> */}
            </div>
          </div>
        </div>
        <div class='col-xl-3 col-sm-6 py-2'>
          <div class='card text-white gradient1 h-100'>
            <div class='card-body'>
              <div class='rotate'>
                <i class='fab fa-twitter fa-4x'></i>
              </div>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Donors")}</h6>
                        <h1 class="display-4 text-white ">{donorCount?donorCount:" "}</h1> */}
              <h6 class='text-uppercase text-white fw-bold'>{t('Donation')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='fa-2xl' icon={faHandHoldingDollar} />
              <h3 className='fs-3 text-white py-2 '>$ {transAmount > 0 ? (Number(totalRecurring)+Number(transAmount)).toFixed(2) : transAmount}</h3>
            </div>
          </div>
        </div>
        <div class='col-xl-3 col-sm-6 py-2'>
          <div class='card text-white gradient2 h-100'>
            <div class='card-body'>
              <div class='rotate'>
                <i class='fa fa-share fa-4x'></i>
              </div>
              <h6 class='text-uppercase text-white fw-bold'>{t('Upcoming Events')}</h6>
              <FontAwesomeIcon style={{ float: 'right' }} className='mr-2 fa-2xl' icon={faCalendarDays} />
              <h1 class='display-5 text-white'>{eventCount < 10 ? '0' + eventCount : eventCount}</h1>
              {/* <h6 class="text-uppercase text-white fw-bold">{t("Shares")}</h6>
                        <h1 class="display-4 text-white">36</h1> */}
            </div>
          </div>
        </div>
      </div>

      <hr style={{ borderTop: '2px solid' }} />

      <div class='row'>
        <div class='col-lg-11 col-md-6 col-sm-12 mt-4 ml-3'>
          <h3 class='mt-3 mb-3 text-dark fs-3 fw-bold'>{t('Donations')}</h3>
          {user.userType == 'O' ? (
            <div class='styled-table '>
              <table class='table text-black  '>
                <thead class='thead-light'>
                  <tr class=''>
                    <th class='text-white'>{t('Organization')}</th>
                    <th>{t('Donation Date')}</th>
                    <th>{t('Cause')}</th>
                    <th>{t('Donation')}</th>
                    <th>{t('Donor Name')}</th>
                  </tr>
                </thead>
                <tbody>
                  {transResponse
                    ? transResponse.slice(0, 10).map((output) => (
                        <tr key={output.id}>
                          <td>{output.organizationName}</td>
                          <td>{output.donationDate.slice(0, 10)}</td>
                          <td>{output.cause}</td>
                          <td>$ {output.amount.slice(0, 6)}</td>
                          <td>
                            {output.firstName} {output.lastName}
                          </td>
                        </tr>
                      ))
                    : ' '}
                </tbody>
              </table>
            </div>
          ) : (
            ' '
          )}
          {orgs && user.userType == 'A' ? (
            <div class='styled-table '>
              <table class='table text-black  '>
                <thead class='thead-light'>
                  <tr class=''>
                    <th class='text-white'>{t('Organization')}</th>
                    <th>{t('Last 24 Hours')}</th>
                    <th>{t('Last Week')}</th>
                    <th>{t('Last Month')}</th>
                  </tr>
                </thead>
                <tbody>
                  {donationData.length > 0
                    ? donationData.map((output) => (
                        <tr key={output.id}>
                          <td>
                            <a
                              onClick={() => {
                                toDonationReport(output);
                              }}
                              style={{ textDecoration: 'underline', color: 'blue' }}
                            >
                              {output.organization}
                            </a>
                          </td>
                          <td>$ {output.last24}</td>
                          <td>$ {output.lastweek}</td>
                          <td>$ {output.lastmonth}</td>
                        </tr>
                      ))
                    : ' '}
                </tbody>
              </table>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard2;
